import { useEffect, useState } from 'react';
import axios from 'axios';

// The reserved, system-locked Customer Price Group every tenant has (see
// backend/controllers/customerPriceGroupController.js's ensureRetailGroup)
// is the anchor every other Group's Price is benchmarked against. Its name
// defaults to "Retail" but a tenant can rename it (e.g. to "MAP") on the
// Customer Price Groups screen — every screen that used to hardcode the
// word "Retail" reads the current name from here instead, so a rename
// takes effect everywhere at once with no redeploy.
export function useAnchorPriceGroupName() {
  const [name, setName] = useState('Retail');

  useEffect(() => {
    axios.get('/api/customer-price-groups')
      .then((res) => {
        const anchor = (res.data.data || []).find((g) => g.is_system_default);
        if (anchor?.name) setName(anchor.name);
      })
      .catch(() => {});
  }, []);

  return name;
}
